export default "__VITE_ASSET__DUMVYHZW__"